(() => {
  const ROOT = '[data-net-reference-header]';
  const FREE_SHIPPING = 9900;

  function formatMoney(cents) {
    if (window.NetReferenceHeaderMoney) return window.NetReferenceHeaderMoney(cents);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));
  }

  /* ---------- Pack / discount display ---------- */

  // Styles for the savings badge, crossed-out price and savings row.
  function injectDiscountStyles() {
    if (document.getElementById('net-ref-cart-discount-styles')) return;
    const style = document.createElement('style');
    style.id = 'net-ref-cart-discount-styles';
    style.textContent = `
      .net-ref-cart-line__badge {
        display: inline-flex; align-items: center; gap: 4px;
        margin: 5px 0 2px; padding: 2px 7px;
        border-radius: 3px;
        background: rgba(123,11,43,0.08);
        color: rgb(123,11,43);
        font-size: 11px; line-height: 1.35; font-weight: 700;
      }
      .net-ref-cart-line__badge svg { width: 11px; height: 11px; flex: 0 0 auto; }
      .net-ref-cart-line__price { display: flex; flex-direction: column; align-items: flex-end; gap: 1px; }
      .net-ref-cart-line__price-compare {
        color: rgb(125,125,125); font-size: 12px; font-weight: 500;
        text-decoration: line-through;
      }
      .net-ref-cart-line__price-final { color: rgb(123,11,43); font-weight: 700; }
      .net-ref-cart-savings {
        display: flex; justify-content: space-between; align-items: baseline; gap: 12px;
        margin: 0 0 6px;
        color: rgb(123,11,43); font-size: 13px; font-weight: 700;
      }
      .net-ref-cart-savings[hidden] { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  const TAG_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" fill="currentColor"><path d="M1 2a1 1 0 0 1 1-1h5.6a1 1 0 0 1 .7.3l6.4 6.4a1 1 0 0 1 0 1.4l-5.6 5.6a1 1 0 0 1-1.4 0L1.3 8.3A1 1 0 0 1 1 7.6V2Zm3.5 3.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/></svg>';

  // Real discount Shopify applied to this line (works with automatic discounts).
  function getLineDiscount(item) {
    const allocations = item.line_level_discount_allocations || [];
    let amount = allocations.reduce((sum, a) => sum + Number(a.amount || 0), 0);
    if (!amount && Array.isArray(item.discounts)) {
      amount = item.discounts.reduce((sum, d) => sum + Number(d.amount || 0), 0);
    }
    if (!amount) {
      amount = Math.max(0, Number(item.original_line_price || 0) - Number(item.final_line_price ?? item.original_line_price ?? 0));
    }
    return amount;
  }

  function getLineBadge(item, discount) {
    if (!discount) return '';
    const original = Number(item.original_line_price || item.line_price || 0) || 1;
    const percent = Math.round((discount / original) * 100);
    const packSize = item.properties && item.properties._net_pack_size;
    const label = packSize && Number(packSize) > 1
      ? `Pack of ${packSize} · ${percent}% off applied`
      : `Buy more & save · ${percent}% off applied`;
    return `<div class="net-ref-cart-line__badge">${TAG_ICON}<span>${escapeHtml(label)}</span></div>`;
  }

  function getLinePrice(item, discount) {
    const final = item.final_line_price ?? item.line_price ?? 0;
    if (!discount) return escapeHtml(formatMoney(final));
    const original = Number(final) + discount;
    return `<span class="net-ref-cart-line__price-compare">${escapeHtml(formatMoney(original))}</span>
            <span class="net-ref-cart-line__price-final">${escapeHtml(formatMoney(final))}</span>`;
  }

  // "Pack savings −$9.50" row, placed just above the Subtotal row.
  function renderSavings(subtotalEl, cart) {
    if (!subtotalEl) return;
    const row = subtotalEl.parentElement;
    if (!row || !row.parentElement) return;

    let savings = row.parentElement.querySelector('[data-net-cart-savings]');
    if (!savings) {
      savings = document.createElement('div');
      savings.className = 'net-ref-cart-savings';
      savings.setAttribute('data-net-cart-savings', '');
      savings.innerHTML = '<span>Pack savings</span><span data-net-cart-savings-amount></span>';
      row.parentElement.insertBefore(savings, row);
    }

    const totalSaved = (cart.items || []).reduce((sum, item) => sum + getLineDiscount(item), 0);
    savings.hidden = totalSaved <= 0;
    savings.querySelector('[data-net-cart-savings-amount]').textContent = `−${formatMoney(totalSaved)}`;
  }

  function initCart(header) {
    if (header.dataset.netCartInit === 'true') return;
    header.dataset.netCartInit = 'true';

    const drawer = header.querySelector('[data-net-cart-drawer]');
    const overlay = header.querySelector('[data-net-cart-overlay]');
    const openBtn = header.querySelector('[data-net-cart-open]');
    const closeBtn = header.querySelector('[data-net-cart-close]');
    const removeAllBtn = header.querySelector('[data-net-cart-remove-all]');
    const cartStatus = header.querySelector('[data-net-cart-status]');
    const lines = header.querySelector('[data-net-cart-lines]');
    const count = header.querySelector('[data-net-cart-count]');
    const subtotal = header.querySelector('[data-net-cart-subtotal]');
    const shippingMessage = header.querySelector('[data-net-shipping-message]');
    const shippingBar = header.querySelector('[data-net-shipping-bar]');
    if (!drawer || !overlay || !openBtn || !lines) return;
    injectDiscountStyles();

    let previousFocus = null;
    let oldBodyPadding = '';
    let busy = false;

    function setPageLock(locked) {
      const pageWrapper = document.querySelector('.page-wrapper');
      pageWrapper?.classList.remove('page-wrapper--drawer-open');
      if (locked) {
        const scrollBar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        oldBodyPadding = document.body.style.paddingRight;
        if (scrollBar) document.body.style.paddingRight = `${scrollBar}px`;
        document.body.classList.add('net-ref-cart-lock');
      } else {
        document.body.classList.remove('net-ref-cart-lock');
        document.body.style.paddingRight = oldBodyPadding;
      }
    }

    function openDrawer() {
      if (header.dataset.pageType === 'cart') return;
      previousFocus = document.activeElement;
      overlay.hidden = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      setPageLock(true);
      requestAnimationFrame(() => overlay.classList.add('is-open'));
      closeBtn?.focus({ preventScroll: true });
      refreshCart();
    }

    function closeDrawer() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      setPageLock(false);
      window.setTimeout(() => { if (!drawer.classList.contains('is-open')) overlay.hidden = true; }, 210);
      previousFocus?.focus?.({ preventScroll: true });
    }

    function renderCart(cart) {
      if (!cart) return;
      if (removeAllBtn) removeAllBtn.hidden = !cart.items?.length;
      count.textContent = cart.item_count ?? 0;
      subtotal.textContent = formatMoney(cart.total_price || 0);
      const remaining = Math.max(0, FREE_SHIPPING - (cart.total_price || 0));
      const pct = Math.min(100, ((cart.total_price || 0) / FREE_SHIPPING) * 100);
      shippingMessage.innerHTML = remaining > 0
        ? `You're <strong>${escapeHtml(formatMoney(remaining))}</strong> away from <strong>Free Shipping!</strong>`
        : `<strong>You've unlocked Free Shipping!</strong>`;
      shippingBar.style.width = `${pct}%`;
      renderSavings(subtotal, cart);

      if (!cart.items?.length) {
        lines.innerHTML = '<div class="net-ref-cart-empty">Your cart is empty.</div>';
        return;
      }

      lines.innerHTML = cart.items.map((item, index) => {
        const image = item.featured_image?.url || item.image || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="net-ref-cart-line__variant">${escapeHtml(item.variant_title)}</div>` : '';
        const discount = getLineDiscount(item);
        return `<div class="net-ref-cart-line" data-net-line data-key="${escapeHtml(item.key)}">
          <a class="net-ref-cart-line__image" href="${escapeHtml(item.url || '#')}">${image ? `<img src="${escapeHtml(image)}&width=140" alt="${escapeHtml(item.product_title || item.title)}" width="70" height="70" loading="lazy">` : ''}</a>
          <div class="net-ref-cart-line__body">
            <a class="net-ref-cart-line__title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title)}</a>
            ${variant}
            ${getLineBadge(item, discount)}
            <div class="net-ref-cart-line__controls">
              <div class="net-ref-cart-qty">
                <button type="button" data-net-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-net-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <button class="net-ref-cart-remove" type="button" data-net-remove>Remove</button>
            </div>
          </div>
          <div class="net-ref-cart-line__price">${getLinePrice(item, discount)}</div>
        </div>`;
      }).join('');
    }

    async function refreshCart() {
      try {
        const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!res.ok) throw new Error('cart fetch failed');
        renderCart(await res.json());
      } catch (err) {
        console.warn('[reference-header] Could not refresh cart', err);
      }
    }

    async function mutateCart(endpoint, body, clearing = false) {
      if (busy) return;
      busy = true;
      if (removeAllBtn) removeAllBtn.disabled = true;
      if (cartStatus) cartStatus.textContent = clearing ? 'Removing all items…' : '';
      lines.setAttribute('aria-busy', 'true');
      lines.style.opacity = '.55';
      try {
        const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${rootPath}cart/${endpoint}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('cart change failed');
        const cart = await res.json();
        renderCart(cart);
        if (clearing) {
          if (cartStatus) cartStatus.textContent = 'All items removed. Your cart is empty.';
          closeBtn?.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('net-reference-cart:updated', { detail: { cart } }));
      } catch (err) {
        console.warn('[reference-header] Could not update cart', err);
        if (cartStatus) cartStatus.textContent = 'Could not update your cart. Please try again.';
        await refreshCart();
      } finally {
        busy = false;
        if (removeAllBtn) removeAllBtn.disabled = false;
        lines.removeAttribute('aria-busy');
        lines.style.opacity = '';
      }
    }

    function changeLine(key, quantity) {
      return mutateCart('change', { id: key, quantity });
    }

    removeAllBtn?.addEventListener('click', () => mutateCart('clear', {}, true));

    openBtn.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
    closeBtn?.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', e => {
      const line = e.target.closest('[data-net-line]');
      if (!line) return;
      const key = line.dataset.key;
      const qtyButton = e.target.closest('[data-net-qty]');
      if (qtyButton) changeLine(key, Number(qtyButton.dataset.netQty));
      if (e.target.closest('[data-net-remove]')) changeLine(key, 0);
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Keep the count synced with common Shopify/theme cart update events.
    ['cart:update','cart:updated','cart-lines-update','cart:refresh','product:added'].forEach(name => {
      document.addEventListener(name, () => window.setTimeout(refreshCart, 50));
    });
    document.addEventListener('net-reference-cart:updated', refreshCart);

    // Product forms and quick-add both publish the standard Shopify cart event.
    const handleCartUpdate = event => {
      const sourceModal = event.target instanceof Element
        ? event.target.closest('dialog:modal')
        : null;
      const onSuccess = ({ detail } = {}) => {
        if (detail?.didError) return;
        refreshCart();
        if (event.action !== 'add' || header.dataset.pageType === 'cart') return;
        // Let quick-add finish closing and restore focus before opening the cart.
        const openAfterModal = () => requestAnimationFrame(openDrawer);
        if (sourceModal?.open) {
          sourceModal.addEventListener('close', openAfterModal, { once: true });
        } else {
          openAfterModal();
        }
      };
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(onSuccess).catch(() => {});
      } else {
        onSuccess();
      }
    };
    ['shopify:cart:lines-update', 'cart-lines-update'].forEach(name => {
      document.addEventListener(name, handleCartUpdate);
    });

    ['net-cart:open', 'cart:open'].forEach(name => {
      document.addEventListener(name, () => openDrawer());
    });

    // Initial count is Liquid-rendered; refresh asynchronously for theme-editor/AJAX navigations.
    refreshCart();
  }

  function boot(scope = document) { scope.querySelectorAll?.(ROOT).forEach(initCart); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
